class EnsurePersonalAccessTokenResult {
    PersonalAccessToken: string;

    constructor(personalAccessToken: string) {
        this.PersonalAccessToken = personalAccessToken;
    }
}

export default EnsurePersonalAccessTokenResult;
